export function openDrawer(state) {
  state.showDrawer = true;
}

export function closeDrawer(state) {
  state.showDrawer = false;
}

export function setOpeningHoursPage(state, data) {
  state.openingHoursPage = data;
}
